import { combineReducers } from 'redux'
import {
  EVENT_KEY_MAP,
  INSTRUMENT_EVENTS_MAP
} from 'utils/constants'
import request from 'utils/request'
import { formatEventBody } from '../../../utils/events'
import { onFetchInstrumentsByArchitecture } from '../../Activities/modules/Instruments'
import { logSentryEvent, SENTRY_MESSAGES } from '../../../utils/sentry'

const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS'
const SET_READ_ANNOUNCEMENT = 'SET_READ_ANNOUNCEMENT'

const filterUnreads = announcements => {
  const unreadArr = []
  announcements.forEach(announcement => {
    const { id, read } = announcement
    if (!read) unreadArr.push(id)
  })
  return unreadArr
}

export const setAnnouncements = payload => {
  const { announcements } = payload
  return {
    type: SET_ANNOUNCEMENTS,
    announcements: announcements.reverse(),
    unread: filterUnreads(announcements)
  }
}

const setReadAnnouncement = id => {
  return {
    type: SET_READ_ANNOUNCEMENT,
    id
  }
}

export const sendAnnouncementsDelivered = announcements => {
  return dispatch => {

    const ids = announcements.map(announcement => String(announcement.id))
    announcements.forEach(announcement => {
      logSentryEvent({
        message: SENTRY_MESSAGES.announcementDelivered,
        tags: {
          flow: 'announcement',
          action: 'delivered',
          announcement_id: announcement?.id != null ? String(announcement.id) : undefined,
          instrument_id: announcement?.instrument_id != null
            ? String(announcement.instrument_id)
            : announcement?.id != null ? String(announcement.id) : undefined,
        },
      })
    })
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/events',
        body: formatEventBody(
          INSTRUMENT_EVENTS_MAP.delivered,
          EVENT_KEY_MAP.instrumentId,
          ids
        ),
        success: () => { }
      })
    )
  }
}

export const sendAnnouncementsSeen = announcements => {
  return dispatch => {

    const ids = announcements.map(announcement => String(announcement.id))
    announcements.forEach(announcement => {
      logSentryEvent({
        message: SENTRY_MESSAGES.announcementSeen,
        tags: {
          flow: 'announcement',
          action: 'seen',
          announcement_id: announcement?.id != null ? String(announcement.id) : undefined,
          instrument_id: announcement?.instrument_id != null
            ? String(announcement.instrument_id)
            : announcement?.id != null ? String(announcement.id) : undefined,
        },
      })
    })
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/events',
        body: formatEventBody(
          INSTRUMENT_EVENTS_MAP.seen,
          EVENT_KEY_MAP.instrumentId,
          ids
        ),
        success: () => { }
      })
    )
  }
}

export const sendAnnouncementsVisible = announcements => {
  return dispatch => {

    const ids = announcements.map(announcement => String(announcement.id))
    announcements.forEach(announcement => {
      logSentryEvent({
        message: SENTRY_MESSAGES.announcementVisible,
        tags: {
          flow: 'announcement',
          action: 'visible',
          announcement_id: announcement?.id != null ? String(announcement.id) : undefined,
          instrument_id: announcement?.instrument_id != null
            ? String(announcement.instrument_id)
            : announcement?.id != null ? String(announcement.id) : undefined,
        },
      })
    })
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/events',
        body: formatEventBody(
          INSTRUMENT_EVENTS_MAP.visible,
          EVENT_KEY_MAP.instrumentId,
          ids
        ),
        success: () => { }
      })
    )
  }
}

export const onFetchAnnouncements = () => {
  return dispatch => {
    logSentryEvent({
      message: 'Inbox flow: check_started',
      tags: {
        flow: 'inbox',
        'inbox.action': 'check_started'
      }
    })
    return dispatch(
      request({
        method: 'GET',
        url: '/control/participants/me/announcements',
        hasLoader: true,
        success: json => {
          logSentryEvent({
            message: 'Inbox flow: check_success',
            tags: {
              flow: 'inbox',
              'inbox.action': 'check_success'
            },
            contexts: {
              inbox: {
                count: json?.announcements?.length || 0
              }
            }
          })
          dispatch(setAnnouncements(json))
          const { announcements } = json
          if (announcements.length > 0) {
            dispatch(sendAnnouncementsDelivered(announcements))
            dispatch(sendAnnouncementsVisible(announcements))
          }
        }
      })
    ).catch(error => {
      logSentryEvent({
        message: 'Inbox flow: check_failed',
        level: 'error',
        tags: {
          flow: 'inbox',
          'inbox.action': 'check_failed'
        },
        error
      })
      throw error
    })
  }
}

export const onAnnouncementRead = id => {
  return dispatch => {

    return dispatch(
      request({
        method: 'POST',
        url: '/control/participants/me/events',
        body: formatEventBody(
          INSTRUMENT_EVENTS_MAP.read,
          EVENT_KEY_MAP.instanceId,
          id
        ),
        success: () => {
          logSentryEvent({
            message: SENTRY_MESSAGES.announcementRead,
            tags: {
              flow: 'announcement',
              action: 'read',
              announcement_id: String(id),
            },
          })
          dispatch(setReadAnnouncement(id))
          dispatch(onFetchInstrumentsByArchitecture(true))
        }
      })
    ).catch(error => {
      logSentryEvent({
        message: 'Inbox flow: announcement_read_failed',
        level: 'error',
        tags: {
          flow: 'inbox',
          'inbox.action': 'announcement_read_failed'
        },
        contexts: {
          inbox: {
            announcementId: String(id)
          }
        },
        error
      })
      throw error
    })
  }
}

const unread = (state = [], action) => {
  switch (action.type) {
    case SET_ANNOUNCEMENTS:
      return action.unread
    case SET_READ_ANNOUNCEMENT:
      return state.filter(id => id !== action.id)
    default:
      return state
  }
}

const announcementsList = (state = [], action) => {
  switch (action.type) {
    case SET_ANNOUNCEMENTS:
      return action.announcements.sort((a, b) => b.id - a.id)
    default:
      return state
  }
}

export default combineReducers({ announcementsList, unread })
